
// Reine Daten-Datei - KEINE Logik hier drin, nur die ligaId-Zuordnungen selbst. Bewusst
// getrennt von ligaTypen.js (der Logik-Datei), damit ein Neuaufbau/eine Änderung der Logik
// NIEMALS versehentlich die hier eingetragenen echten IDs überschreibt (ist schon einmal
// passiert, als ligaTypen.js aus Versehen mit Platzhalter-IDs neu angelegt wurde).
//
// BITTE HIER die echten ligaId-Werte eintragen/pflegen - diese Datei sollte von mir aus nicht
// mehr angefasst werden müssen, außer du bittest explizit darum, neue Einträge zu ergänzen.

export const LARGE_WETTBEWERBE = [
  { id: 5, name: 'Europa League' },
  { id: 14, name: 'Conference League' },
  { id: 42, name: 'Nations League' },
  { id: null, name: 'Copa America' },
  { id: null, name: 'Africa Cup of Nations' }
]

export const XL_WETTBEWERBE = [
  { id: 1, name: 'Champions League' },
  { id: null, name: 'Weltmeisterschaft' },
  { id: null, name: 'Europameisterschaft' },
  { id: null, name: 'Club World Cup' }
]

// ---------- Kategorie-Farben fürs Kalender-Punkte-System ----------
// Bei vielen Ligen an einem Tag wechselt der Kalender von Text-Badges auf kompakte, farbige
// Punkte (siehe KalenderPopover.vue). Farbe wird pro KATEGORIE vergeben, nicht pro einzelner
// Liga - bei 20+ Ligen wären individuelle Farben nicht mehr unterscheidbar.
//
// WICHTIG: id-Werte sind PLATZHALTER (null) - bitte mit den echten ligaId-Werten befüllen.
export const TOP5_LIGEN = [
  { id: 3, name: 'Bundesliga (DE)' },
  { id: 4, name: 'Premier League' },
  { id: 18, name: 'La Liga' },
  { id: 17, name: 'Serie A' },
  { id: 13, name: 'Ligue 1' }
]

export const EUROPAPOKAL_LIGEN = [
  { id: 1, name: 'Champions League' },
  { id: 5, name: 'Europa League' },
  { id: 14, name: 'Conference League' }
]

export const NATIONALMANNSCHAFT_LIGEN = [
  { id: null, name: 'Weltmeisterschaft' },
  { id: null, name: 'Europameisterschaft' },
  { id: null, name: 'Nations League' },
  { id: null, name: 'Copa America' },
  { id: null, name: 'Africa Cup of Nations' }
]